
import type { PropType } from 'vue'

import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        value: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const onInput = (event: Event) => {
            if (props.disabled) return

            const target = event.target as HTMLInputElement
            emit('update:value', target.value)
        }

        const onChange = (event: Event) => {
            if (props.disabled) return

            const target = event.target as HTMLInputElement
            emit('change', target.value)
        }

        return {
            onInput,
            onChange,
        }
    }
})
